<template>
  <div class="hello">
      <transition name="fade">
        <div v-if="showGettingRequests" class="loading">
            <p>Getting Service Requests </p>
        </div>
    </transition>

    <b-container>
        <b-row>
            <b-col>
                <h4 style="margin-top:20px">Your Service Requests</h4>
            </b-col>
        </b-row>

        <!-- Iterate over all service reuests -->
        <template>
            <table class="table" >
                <thead>
                    <tr class="thead-dark">
                        <th ><h5>Service</h5> </th>
                        <th > <h5>Status</h5></th>
                        <th > <h5>Actions</h5></th>
                    </tr>
                </thead>
                <tbody  v-for="service in serviceRequests" :key="service.serviceid+'service'">
                    <!-- Show only if at least one service selected -->
                    <template v-if="service.linecleaning==1||service.kegpickup==1||service.taphandles==1||service.signage==1">
                        <!-- Titles -->
                        <!-- Brewery name and service creation date -->
                        <tr>
                            <td>
                                <h5 style="color:#2e5189" >{{service.brewer}}, Created On {{service.date}}</h5> 
                            </td>
                            <!-- Empty td to line up actions -->
                            <td></td>
                            <td>
                                <!-- Message button -->
                                <b-button size="sm" variant="success" v-b-modal="'SendMsg' + service.serviceid" 
                                    class='btn  btn-secondary action-buttons'><i><font-awesome-icon icon="comment" /></i> Send a Message
                                </b-button>
                                <!-- Message modal -->
                                <b-modal size="lg" :id="'SendMsg' + service.serviceid" title="Send a Message"  hide-footer>
                                    <div class='col-12'>
                                        <sendmessage  :receiverId="service.brewerid" :receiverName="service.brewer"  :arrayDefaultMessages="arrayDefaultMessages"/>
                                    </div>
                                </b-modal>
                            </td>
                        </tr>
                        
                        <!-- Line Cleaning -->
                        <tr v-if="service.linecleaning==1">
                            <td>
                                <span style="padding-left:20px">Line Cleaning</span>
                            </td>
                            <td>
                                {{service.linecleaningstatus}}
                            </td>
                            <td>
                                <!-- Cancel service button -->
                                <b-button   size="sm" v-if="service.linecleaningcompleted==0" variant="outline-danger"  v-b-modal="'cancellinecleaning' + service.serviceid">Cancel</b-button>
                                <!-- Cancel modal -->
                                <b-modal size="lg" :id="'cancellinecleaning' + service.serviceid" title="Cancel Line Cleaning?" ok-title="Yes, Cancel" cancel-title="No, Do Not Cancel"
                                    @ok="cancelService(service.docId, 'linecleaning')">
                                </b-modal>
                            </td>
                        </tr>
                        <!-- Kep Pickup -->
                        <tr v-if="service.kegpickup==1">
                            <td>
                                <span style="padding-left:20px">Empty Keg Pickup</span>
                            </td>
                            <td>
                                {{service.kegpickupstatus}}
                            </td>
                            <td>
                                <!-- Cancel service button -->
                                
                                <b-button  size="sm"  v-if="service.kegpickupcompleted==0" variant="outline-danger"  v-b-modal="'cancelkegpickup' + service.serviceid">Cancel</b-button>
                                <!-- Cancel modal -->
                                <b-modal size="lg" :id="'cancelkegpickup' + service.serviceid" title="Cancel Keg Pick Up?" ok-title="Yes, Cancel" cancel-title="No, Do Not Cancel"
                                    @ok="cancelService(service.docId, 'kegpickup')">
                                </b-modal>
                            </td>
                        </tr>
                        <!-- Tap Handles -->
                        <tr v-if="service.taphandles==1">
                            <td>
                                <span style="padding-left:20px">Tap Handles</span>
                            </td>
                            <td>
                                {{service.taphandlesstatus}}
                            </td>
                            <td>
                                <!-- Cancel service button -->
                                <b-button  size="sm" v-if="service.taphandlescompleted==0" variant="outline-danger"  v-b-modal="'canceltaphandles' + service.serviceid">Cancel</b-button>
                                <!-- Cancel modal -->
                                <b-modal size="lg" :id="'canceltaphandles' + service.serviceid" title="Cancel Tap Handles?" ok-title="Yes, Cancel" cancel-title="No, Do Not Cancel"
                                    @ok="cancelService(service.docId, 'taphandles')">
                                </b-modal>
                            </td>
                        </tr>
                        <!-- Signage -->
                        <tr v-if="service.signage==1">
                            <td>
                                <span style="padding-left:20px">Signage</span>
                            </td>
                            <td>
                                {{service.signagestatus}}
                            </td>
                            <td>
                                <!-- Cancel service button -->
                                <b-button  size="sm"  v-if="service.signagecompleted==0" variant="outline-danger"  v-b-modal="'cancelsignage' + service.serviceid">Cancel</b-button>
                                <!-- Cancel modal -->
                                <b-modal size="lg" :id="'cancelsignage' + service.serviceid" title="Cancel Signage?" ok-title="Yes, Cancel" cancel-title="No, Do Not Cancel"
                                    @ok="cancelService(service.docId, 'signage')">
                                </b-modal>
                            </td>
                        </tr>
                        <!-- Buyer Note -->
                        <tr>
                            <td>
                                <i>Your Notes: <small>{{service.note}}</small></i>
                            </td>
                            <!-- Empty td to align actions -->
                            <td></td>
                            <!-- Edit note button -->
                            <td>
                                <b-button  size="sm" variant="outline-info" v-b-modal="'EditNote' + service.serviceid" 
                                    ><i><font-awesome-icon icon="edit" /></i> Edit Note
                                </b-button>
                                <!-- Notes modal -->
                                <b-modal size="lg" :id="'EditNote' + service.serviceid" title="Edit Note"  hide-footer>
                                    <b-input-group>
                                        <b-form-textarea v-model="service.note" ></b-form-textarea>
                                        <b-input-group-append>
                                            <b-button variant="info" :disabled='!service.note' @click="editServiceNote(service.docId, service.note, service.serviceid)">Update Note</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-modal>
                            </td>
                        </tr>
                        <!-- Seller Note -->
                        <tr v-if="service.sellernote">
                            <td colspan="12">
                                <i>Note from {{service.brewer}}: <strong>{{service.sellernote}}</strong></i>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

        </template>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import {timeConverterDateOnly} from '../Myfunctions'
import Sendmessage from '../Sendmessage'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Sendmessage,
    },

    data() {
        return {
            serviceRequests:[],
            showGettingRequests:false,
            arrayDefaultMessages:[],
            sendMessageModalVisible:false
        }
    },

    methods:{
        //Get all services
        getServiceRequests(){
            this.serviceRequests=[]
            this.showGettingRequests=true
            fb.servicesCollection.where("pubid", "==", this.currentUser.uid).get().then(docs => {
                docs.forEach(doc => {
                    //Get minimum price
                    var serviceData = doc.data()
                    serviceData.docId = doc.id
                    //Format date
                    if (serviceData.createdOn) {
                        serviceData.date = timeConverterDateOnly(serviceData.createdOn.seconds)
                    }

                    //Create status of each service
                    if(serviceData.linecleaning){
                        if(serviceData.linecleaningcompleted==-1) serviceData.linecleaningstatus="Cancelled"
                        else if(serviceData.linecleaningcompleted==0) serviceData.linecleaningstatus="Open"
                        else if(serviceData.linecleaningcompleted==1) serviceData.linecleaningstatus="Complete"
                    }
                    if(serviceData.kegpickup){
                        if(serviceData.kegpickupcompleted==-1) serviceData.kegpickupstatus="Cancelled"
                        else if(serviceData.kegpickupcompleted==0) serviceData.kegpickupstatus="Open"
                        else if(serviceData.kegpickupcompleted==1) serviceData.kegpickupstatus="Complete"
                    }
                    if(serviceData.taphandles){
                        if(serviceData.taphandlescompleted==-1) serviceData.taphandlesstatus="Cancelled"
                        else if(serviceData.taphandlescompleted==0) serviceData.taphandlesstatus="Open"
                        else if(serviceData.taphandlescompleted==1) serviceData.taphandlesstatus="Complete"
                    }
                    if(serviceData.signage){
                        if(serviceData.signagecompleted==-1) serviceData.signagestatus="Cancelled"
                        else if(serviceData.signagecompleted==0) serviceData.signagestatus="Open"
                        else if(serviceData.signagecompleted==1) serviceData.signagestatus="Complete"
                    }
                    
                    this.serviceRequests.push(serviceData)
                    //Add to brewers list
                })
            }).then(res => {
                this.showGettingRequests=false
            })
            .catch(res => {
                this.showGettingRequests=false
            })

        },

        //Cancel a service
        cancelService(docid, service){
            fb.servicesCollection.doc(docid).update({[service] : 0});
            //Get services again
            this.$bvToast.toast('This service has been cancelled', {
                title: 'Service Cancelled!',
                solid:true,
                variant: 'warning',
                autoHideDelay: 5000,
                appendToast: false
                })
            this.getServiceRequests()
        },
        //Edit service note
        editServiceNote(docid, note, serviceid){
            console.log("Editing note for docId: " + docid)
            console.log("New note: " + note)
            //Update note
            fb.servicesCollection.doc(docid).update({note : note});

            this.$bvToast.toast('Service note has been updated', {
                title: 'Note Updated!',
                solid:true,
                variant: 'info',
                autoHideDelay: 5000,
                appendToast: false
                })
            //Hide the notes modal
            this.$bvModal.hide("EditNote" + serviceid)
        }
    },

    mounted(){
        this.getServiceRequests()
    },
}
</script>

